import React, { useMemo } from 'react';
import DENTModalOverviewSubButtonsSelection from '../DENTModalOverviewSubButtonsSelection/DENTModalOverviewSubButtonsSelection';
import { ToothEndodonticPain } from '../../../../graphql/graphql';

interface Props {
	value?: ToothEndodonticPain;
	onChange: (value: ToothEndodonticPain) => void;
}

export const DENTModalOverviewGeneralEndodonticPainButtons = ({
	value,
	onChange,
}: Props) => {
	const rows = useMemo(
		() => [
			{
				shouldHide: false,
				items: [
					{
						title:
							'patientTreatment.meddiDENT.dentalCross.endodontic.notPainful',
						isSelected: value === ToothEndodonticPain.NotPainful,
						onClick: () => onChange(ToothEndodonticPain.NotPainful),
					},
					{
						title:
							'patientTreatment.meddiDENT.dentalCross.endodontic.unpleasant',
						isSelected: value === ToothEndodonticPain.Unpleasant,
						onClick: () => onChange(ToothEndodonticPain.Unpleasant),
					},
					{
						title: 'patientTreatment.meddiDENT.dentalCross.endodontic.painful',
						isSelected: value === ToothEndodonticPain.Painful,
						onClick: () => onChange(ToothEndodonticPain.Painful),
					},
				],
			},
		],
		[value, onChange],
	);

	return <DENTModalOverviewSubButtonsSelection rows={rows} />;
};

export default DENTModalOverviewGeneralEndodonticPainButtons;
